import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Mail, Menu, Phone, X } from "lucide-react";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/a-propos", label: "À propos" },
  { to: "/formations", label: "Formations" },
  { to: "/bourses", label: "Bourses" },
  { to: "/blogue", label: "Blogue" },
  { to: "/impact", label: "Notre impact" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-background/85 backdrop-blur-xl" data-testid="site-header">
      <div className="border-b border-espresso-border bg-espresso text-ivory" data-testid="header-contact-bar">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-6 py-2 text-xs font-medium sm:justify-end sm:gap-8 lg:px-10">
          <a href="mailto:info@fondationhora.org" className="inline-flex min-w-0 items-center gap-2 transition-colors hover:text-gold" data-testid="header-email">
            <Mail size={14} className="shrink-0 text-gold" />
            <span className="truncate">info@fondationhora.org</span>
          </a>
          <a href="tel:+15148977111" className="inline-flex shrink-0 items-center gap-2 transition-colors hover:text-gold" data-testid="header-phone">
            <Phone size={14} className="text-gold" />
            <span>514 897-7111</span>
          </a>
        </div>
      </div>
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <Link to="/" className="flex items-center" data-testid="logo-link">
          <img src="/logo-hora-light.png" alt="Fondation HORA" className="h-11 w-auto" data-testid="logo-image" />
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="main-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to === "/" ? "accueil" : l.to.slice(1)}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors duration-200 hover:text-primary ${
                  isActive ? "text-primary" : "text-foreground/70"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/devenir-benevole"
            data-testid="benevole-button"
            className="rounded-sm border border-primary px-5 py-2.5 text-sm font-semibold text-primary transition-[background-color,color,transform] duration-200 hover:-translate-y-0.5 hover:bg-primary hover:text-primary-foreground"
          >
            Devenir bénévole
          </Link>
          <Link
            to="/don"
            data-testid="donate-button"
            className="rounded-sm bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[hsl(22,83%,40%)]"
          >
            Faire un don
          </Link>
        </nav>

        <button
          className="lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="mobile-menu-button"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <nav className="border-t border-border bg-background px-6 pb-6 pt-4 lg:hidden" data-testid="mobile-nav">
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-${l.to === "/" ? "accueil" : l.to.slice(1)}`}
                className={({ isActive }) =>
                  `font-serif text-xl ${isActive ? "text-primary" : "text-foreground/80"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/devenir-benevole"
              data-testid="mobile-benevole-button"
              className="mt-2 w-fit rounded-sm border border-primary px-5 py-2.5 text-sm font-semibold text-primary"
            >
              Devenir bénévole
            </Link>
            <Link
              to="/don"
              data-testid="mobile-donate-button"
              className="w-fit rounded-sm bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground"
            >
              Faire un don
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
};
